import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  cta: {
    id: 'seo_blue_beetle_learn_immerse_cta',
  },
  learnablesLabel: {
    id: 'seo_blue_beetle_learn_immerse_words',
  },
  topic: {
    id: 'seo_blue_beetle_learn_immerse_title',
  },
});

export const en = defineMessages({
  text: {
    id: 'seo_blue_beetle_learn_immerse_header_text_en',
  },
  title: {
    id: 'seo_blue_beetle_learn_immerse_subtitle_en',
  },
});

export const en_us = defineMessages({
  text: {
    id: 'seo_blue_beetle_learn_immerse_header_text_en_us',
  },
  title: {
    id: 'seo_blue_beetle_learn_immerse_subtitle_en_us',
  },
});

export const es = defineMessages({
  text: {
    id: 'seo_blue_beetle_learn_immerse_header_text_es',
  },
  title: {
    id: 'seo_blue_beetle_learn_immerse_subtitle_es',
  },
});

export const es_mx = defineMessages({
  text: {
    id: 'seo_blue_beetle_learn_immerse_header_text_es_mx',
  },
  title: {
    id: 'seo_blue_beetle_learn_immerse_subtitle_es_mx',
  },
});
